<template>
    <md-table-cell>
        <md-datepicker v-model="filterValue" :md-debounce="debounceTime"/>
    </md-table-cell>
</template>

<script>
    import {mapGetters, mapMutations} from "vuex";
    import _ from 'lodash';
    import moment from "moment";

    export default {
        name: "IndexTableFilterDate",
        props: {
            slug: {
                type: String,
                required: true,
            }
        },
        data: () => ({
            filterValue: null
        }),
        computed: {
            debounceTime(){
                return Number(200);},
            ...mapGetters('indexTable', {
                filter: 'getFilter',
            })
        },
        methods: {
            ...mapMutations('indexTable', {
                setFilter: 'setFilter',
            })
        },
        watch: {
            filterValue: _.debounce(function (newVal,oldVal) {
                if(this.filterValue !== null){
                    let dateString = moment(new Date(this.filterValue)).format("YYYY-MM-DD");
                    if(dateString !==  moment(new Date(oldVal)).format("YYYY-MM-DD")){
                        this.setFilter({column: this.slug, value: dateString});
                    }
                } else {
                    this.setFilter({column: this.slug, value: this.filterValue});
                }
                }, 200)
        }

    }
</script>

